import { RitzAPI, } from '@moderepo/mode-internal-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var ProjectHomesActionType;
(function (ProjectHomesActionType) {
    ProjectHomesActionType["SET_PROJECT_HOMES"] = "set project homes";
    ProjectHomesActionType["CLEAR_PROJECT_HOMES"] = "clear project homes";
})(ProjectHomesActionType || (ProjectHomesActionType = {}));
export const setProjectHomes = (projectId, homes, searchParams) => {
    return {
        type: ProjectHomesActionType.SET_PROJECT_HOMES,
        projectId,
        homes,
        searchParams,
    };
};
export const clearProjectHomes = (projectId) => {
    return {
        type: ProjectHomesActionType.CLEAR_PROJECT_HOMES,
        projectId,
    };
};
/**
 * Get all homes belonged to a Project
 * @param projectId - The id of the Project to look for
 */
export const fetchProjectHomes = (projectId, pageNumber, pageSize) => {
    return async (dataDispatch) => {
        const homes = await RitzAPI.getInstance().getProjectHomes(projectId, pageNumber !== undefined && pageSize !== undefined ? pageNumber * pageSize : undefined, pageSize);
        await dataDispatch(setProjectHomes(projectId, homes, searchParamsToString({
            pageNumber, pageSize,
        })));
    };
};
